const ProdutosControleLoteController = ControllerBase.extend({
    name: "ProdutosControleLoteController",

    framework: "knockout",

    ajax: function () {

        return {
            url: "/Orcamento/_ProdutosControleLote",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
            }
        };
    },

    newModel: function () {
        return {
            Lotes: []
        };
    },

    antesBinding: function () {

    },

    reservar: function (model) {


        this.lotesProdutoController = this.showView({
            region: {
                name: "lotesProdutoRegion",
                selector: "#lotes-produto-region"
            },
            model: this.toJS(model),
            controller: {
                type: LotesProdutoController,
                args: {
                    orcamento: this.orcamento,
                    codigoObjetoItem: model.CodigoObjetoItemOrcamento()
                }
            }
        });


    }

})

window.ProdutosControleLoteController = ProdutosControleLoteController

export {ProdutosControleLoteController}